import { forwardRef } from "react";
import { bool, node, string } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../Styles.variables";

const ButtonLink = forwardRef(
  ({ children, color, underline, ...rest }, ref) => {
    return !!children ? (
      <Button {...rest} color={color} underline={underline} ref={ref}>
        {children}
      </Button>
    ) : null;
  }
);

const Button = styled.button`
  appearance: none;
  background: none;
  border: 0 none;
  color: ${({ color }) =>
    !!color && !!colors[color] ? colors[color] : "inherit"};
  display: inline;
  line-height: 1;
  margin: 0;
  padding: 0;
  text-decoration: ${({ underline }) => (underline ? "underline" : "none")};
  user-select: none;
  white-space: nowrap;

  &:hover {
    text-decoration: ${({ underline }) => (underline ? "none" : "underline")};
  }

  &:active,
  &:focus {
    outline: ${rem("1px")} dotted;
    outline-offset: 0.25em;
  }
`;

ButtonLink.propTypes = {
  children: node.isRequired,
  color: string,
  type: string,
  underline: bool,
};

ButtonLink.defaultProps = {
  color: null,
  type: "button",
  underline: false,
};

export default ButtonLink;
